// extracted by mini-css-extract-plugin
export default {"title":"AltaUsuario_title__43usG","sendBtn":"AltaUsuario_sendBtn__hcDni"};